import { Avatar } from "@base-ui/react/avatar";
import Image from "next/image";
import verified from "#/assets/badge/verified-badge.svg";
import type { Author } from "@/types/content";

interface Props {
  user: Author | null;
}
const UserCard = ({ user }: Props) => {
  if (!user) {
    return (
      <div className="flex flex-row gap-3 items-center">
        <Avatar.Root className="inline-flex size-12 items-center justify-center overflow-hidden rounded-full bg-gray-100 align-middle text-base font-medium text-gray-900 select-none">
          <Avatar.Fallback className="flex size-full items-center justify-center text-base">
            NU
          </Avatar.Fallback>
        </Avatar.Root>
        <div className="text-[12px] leading-4.5 font-semibold">
          <h3 className="inline-flex justify-center items-center gap-1">
            .....
          </h3>
          <h3 className="font-medium opacity-90">...</h3>
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-row gap-3 items-center">
      <Avatar.Root className="inline-flex size-12 items-center justify-center overflow-hidden rounded-full bg-gray-100 align-middle text-base font-medium text-gray-900 select-none">
        <Avatar.Image
          className="size-full object-cover"
          height="48"
          src={user.avatar}
          width="48"
        />
        <Avatar.Fallback className="flex size-full items-center justify-center text-base">
          {user.name
            .split(" ")
            .map((a) => a[0])
            .join()}
        </Avatar.Fallback>
      </Avatar.Root>
      <div className="text-[12px] leading-4.5 font-semibold">
        <h3 className="inline-flex justify-center items-center gap-1">
          {user.name}
          {user.isVerified && (
            <Image alt="verified user" height={16} src={verified} width={16} />
          )}
        </h3>
        <h3 className="font-medium opacity-90">{user.title}</h3>
      </div>
    </div>
  );
};

export default UserCard;
